@let headlineId = 'selected-contract-view-headline';

<a
    [routerLink]="['portal', 'dashboard']"
    class="fw:semibold c:grey-1"
>
    <i ctrlIcon="chevron_left"></i> <span>Zurück zum Dashboard</span></a
>
<app-page-header
    headline="Ausgewählter Vertrag"
    [headlineId]="headlineId"
/>
<app-contract-select
    class="m-16:b"
    [labeledBy]="headlineId"
    [contracts]="contracts()"
    [currentContract]="contract()"
    (selectContract)="handleContractSelect($event)"
></app-contract-select>
<div class="contract-widget-container">
    @if (contract()) {
        <app-contract-widget-container [contract]="contract()"></app-contract-widget-container>
    }
</div>
@if (otherContracts().length > 0) {
    <div class="m-32:t md:m-48:t">
        <h1
            id="other-contracts-section-headline"
            class="c:blue-700"
        >
            Deine anderen Verträge
        </h1>
        <app-contract-list
            [contracts]="otherContracts()"
            route="/portal/meine-vertraege/:contractId"
        />
    </div>
}
